var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-dialog",
    {
      attrs: {
        "md-active": _vm.active,
        "md-close-on-esc": false,
        "md-click-outside-to-close": false
      },
      on: {
        "update:mdActive": function($event) {
          _vm.active = $event
        },
        "update:md-active": function($event) {
          _vm.active = $event
        }
      }
    },
    [
      _c("md-dialog-title", [
        _vm._v(
          _vm._s(_vm.i18n.lbl_sub()) + " - " + _vm._s(_vm.values.Description)
        )
      ]),
      _vm._v(" "),
      _c("input-field2", {
        attrs: {
          label: _vm.i18n.lbl_client(),
          "sec-label": _vm.i18n.lbl_new_client(),
          list: _vm.clients
        },
        model: {
          value: _vm.form.client,
          callback: function($$v) {
            _vm.$set(
              _vm.form,
              "client",
              typeof $$v === "string" ? $$v.trim() : $$v
            )
          },
          expression: "form.client"
        }
      }),
      _vm._v(" "),
      _c("input-field2", {
        attrs: {
          label: _vm.i18n.lbl_direction(),
          "sec-label": _vm.i18n.lbl_new_dir(),
          list: _vm.descriptions
        },
        model: {
          value: _vm.form.desc,
          callback: function($$v) {
            _vm.$set(
              _vm.form,
              "desc",
              typeof $$v === "string" ? $$v.trim() : $$v
            )
          },
          expression: "form.desc"
        }
      }),
      _vm._v(" "),
      _c(
        "md-dialog-actions",
        [
          _c(
            "md-button",
            {
              staticClass: "md-button btn md-primary md-theme-default",
              attrs: { disabled: _vm.isLoading },
              on: {
                click: function($event) {
                  return _vm.$emit("close")
                }
              }
            },
            [_vm._v(_vm._s(_vm.i18n.lbl_cancel()))]
          ),
          _vm._v(" "),
          _c(
            "md-button",
            {
              staticClass: "md-button btn md-primary md-theme-default",
              attrs: { disabled: _vm.sendDisabled },
              on: { click: _vm.send }
            },
            [_vm._v(_vm._s(_vm.i18n.lbl_send()))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f4c07c68", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f4c07c68","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/dashboard/index/ChangeSubwalletModal.vue
// module id = KJzz
// module chunks = 1